import { Routes } from '@angular/router';
import { AuthGuard } from '@i7/shared';

export const basRoutes: Routes = [
  {
    path: 'job',
    loadChildren: () =>
      import('../pages/bas/job/job.module').then(
        (module) => module.JobModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "cadastro-generico",
    loadChildren: () =>
      import("../pages/cad/cadastro-generico/cadastro-generico.module").then(
        (module) => module.CadastroGenericoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "relacao-generica",
    loadChildren: () =>
      import("../pages/bas/relacao-generica/relacao-generica.module").then(
        (module) => module.RelacaoGenericaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'usuario',
    loadChildren: () =>
      import('../pages/bas/usuario/usuario.module').then(
        (module) => module.UsuarioModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'sessao',
    loadChildren: () =>
      import('../pages/bas/sessao/sessao.module').then(
        (module) => module.SessaoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'programa',
    loadChildren: () =>
      import('../pages/bas/programa/programa.module').then(
        (module) => module.ProgramaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "auditoria",
    loadChildren: () =>
      import("../pages/bas/auditoria/auditoria.module").then(
        (module) => module.AuditoriaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'consulta-log-acesso',
    loadChildren: () => import('../pages/bas/consulta-log-acesso/consulta-log-acesso.module').then(
      (module) => module.ConsultaLogAcessoModule
    ),
    canActivate: [AuthGuard],
  },
  {
    path: "parametro-generico",
    loadChildren: () =>
      import("../pages/bas/parametros-genericos/parametros-genericos.module").then(
        (module) => module.ParametrosGenericosModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "modulo",
    loadChildren: () =>
      import("../pages/bas/modulo/modulo.module").then(
        (module) => module.ModuloModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'kanban',
    loadChildren: () =>
      import('../pages/bas/kanban/kanban.routes').then(
        (routes) => routes.KANBAN_ROUTES,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'saldo',
    loadChildren: () =>
      import('../pages/bas/saldo/saldo.module').then(
        (module) => module.SaldoModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'papel/novo',
    loadComponent: () =>
      import('../pages/bas/papel/form/papel-form.component').then(
        (component) => component.PapelFormComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'papel/:id',
    loadComponent: () =>
      import('../pages/bas/papel/form/papel-form.component').then(
        (component) => component.PapelFormComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'papel',
    loadComponent: () =>
      import('../pages/bas/papel/list/papel-list.component').then(
        (component) => component.PapelListComponent,
      ),
    canActivate: [AuthGuard],
  },  {
    path: 'notificacao-layout/novo',
    loadComponent: () =>
      import('../pages/bas/notificacao/notificacao-layout/form/notificacao-layout-form.component').then(
        (component) => component.NotificacaoLayoutFormComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'notificacao-layout/:id',
    loadComponent: () =>
      import('../pages/bas/notificacao/notificacao-layout/form/notificacao-layout-form.component').then(
        (component) => component.NotificacaoLayoutFormComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'notificacao-layout',
    loadComponent: () =>
      import('../pages/bas/notificacao/notificacao-layout/list/notificacao-layout-list.component').then(
        (component) => component.NotificacaoLayoutListComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'notificacao-canal/novo',
    loadComponent: () => import('../pages/bas/notificacao/notificacao-canal/form/notificacao-canal-form.component').then((component) => component.NotificacaoCanalFormComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'notificacao-canal/:id',
    loadComponent: () => import('../pages/bas/notificacao/notificacao-canal/form/notificacao-canal-form.component').then((component) => component.NotificacaoCanalFormComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'notificacao-canal',
    loadComponent: () => import('../pages/bas/notificacao/notificacao-canal/list/notificacao-canal-list.component').then((component) => component.NotificacaoCanalListComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'integracao',
    loadChildren: () =>
      import('../pages/bas/integracao/integracao.routes').then(
        (routes) => routes.INTEGRACAO_ROUTES,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'notificacao',
    loadChildren: () =>
      import('../pages/bas/notificacao/notificacao.routes').then(
        (routes) => routes.NOTIFICACAO_ROUTES,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'notificacao-monitor',
    loadComponent: () =>
      import('../pages/bas/notificacao/notificacao-monitor/list/notificacao-monitor-list.component').then(
        (component) => component.NotificacaoMonitorListComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'monitor-fila-email',
    loadChildren: () =>
      import('../pages/bas/monitor-fila-email/monitor-fila-email.module').then(
        (module) => module.MonitorFilaEmailModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'indice',
    loadChildren: () =>
      import('../pages/bas/indice/indice.module').then(
        (module) => module.IndiceModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'aplicacao',
    loadChildren: () =>
      import('../pages/bas/aplicacao/aplicacao.module').then(
        (module) => module.AplicacaoModule
      ),
    canActivate: [AuthGuard],
  },
];


